import { render, staticRenderFns } from "./TypeWellText.vue?vue&type=template&id=62e0a706&scoped=true"
import script from "./TypeWellText.vue?vue&type=script&lang=ts"
export * from "./TypeWellText.vue?vue&type=script&lang=ts"
import style0 from "./TypeWellText.vue?vue&type=style&index=0&id=62e0a706&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0a706",
  null
  
)

export default component.exports